<template>
  <!-- 整張卡片可點擊 -->
  <router-link
    class="course"
    :to="`/course/${course.id}`"   
  >
    <div class="thumb-wrap">
      <img :src="course.cover" :alt="course.title" class="thumb" />
      <div v-if="course.isPaid" class="ribbon">付費會員</div>
    </div>

    <div class="body">
      <h3 class="title">{{ course.title }}</h3>
      <p class="desc">{{ course.desc }}</p>
    </div>

    <div class="meta">
      <div class="left">
        <span class="dot-icon">
          <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/></svg>
        </span>
        <span class="muted">{{ course.lessonsCount }} Lessons</span>
        <span class="muted">• {{ course.level }}</span>
      </div>
      <button class="more" aria-label="more">
        <svg viewBox="0 0 24 24">
          <circle cx="5" cy="12" r="1.8" />
          <circle cx="12" cy="12" r="1.8" />
          <circle cx="19" cy="12" r="1.8" />
        </svg>
      </button>
    </div>
  </router-link>
</template>
<script setup>
defineProps({
  course: { type: Object, required: true }
})
</script>

<style scoped>
/* ========== 卡片結構 ========== */
.course {
  display: flex;
  flex-direction: column;
  height: 100%; /* ✅ 等高模式關鍵 */
  overflow: hidden;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
  color: #fff;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  text-decoration: none;      /* 去掉超連結下劃線 */
  cursor: pointer;            /* 滑鼠變手 */
}

.course:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45), 0 0 18px rgba(255, 255, 255, 0.08);
}

/* ========== 封面區 ========== */
.thumb-wrap {
  position: relative;
}
.thumb {
  width: 100%;
  height: 180px;
  object-fit: cover;
  display: block;
}
.ribbon {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 12px;
  font-weight: 800;
  padding: 6px 10px;
  border-radius: 8px;
  background: linear-gradient(135deg, #f7c94b, #f08f2e);
  color: #111;
  box-shadow: var(--shadow-glow);
}

/* ========== 文字主體區 ========== */
.body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto; /* ✅ 讓正文撐開高度，meta 永遠貼底 */
  padding: 14px 16px 14px;
  margin: 0;
}
.title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 800;
  color: #fff;
}
.desc {
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.7;
  font-size: 14px;
  /* 限制顯示行數（可選） */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ========== 底欄區（meta） ========== */
.meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto; /* ✅ 把它壓到底部 */
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding: 10px 14px 12px;
  background: rgba(255, 255, 255, 0.04);
}
.left {
  display: flex;
  gap: 8px;
  align-items: center;
}
.dot-icon {
  width: 18px;
  height: 18px;
  display: inline-grid;
  place-items: center;
}
.dot-icon svg {
  width: 14px;
  height: 14px;
  fill: #fff;
  opacity: 0.9;
}
.muted {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
}
.more {
  background: none;
  border: 0;
  padding: 6px;
  border-radius: 8px;
}
.more svg {
  width: 18px;
  height: 18px;
  fill: rgba(255, 255, 255, 0.9);
}
.more:hover {
  background: rgba(255, 255, 255, 0.08);
}

/* 兜底：最後元素不允許有外邊距 */
.course > :last-child {
  margin-bottom: 0 !important;
}
</style>

